import Enums from 'utils/EnumsManager';

const { REDUX_ACTION_TYPE_PREFIX } = Enums;
const { CONVERSION } = REDUX_ACTION_TYPE_PREFIX;

export const SET_DETAILS = `${CONVERSION}_SET_DETAILS`;
export const SET_SIMILAR_DATA = `${CONVERSION}_SET_SIMILAR_DATA`;
export const SET_OWNERS = `${CONVERSION}_SET_OWNERS`;
export const SET_FIELD_VALUE = `${CONVERSION}_SET_FIELD_VALUE`;
export const SET_STATUSES = `${CONVERSION}_SET_STATUSES`;
export const RESET = `${CONVERSION}_RESET`;
export const SET_OPPORT_TYPES = `${CONVERSION}_SET_OPPORT_TYPES`;



// WEBPACK FOOTER //
// ./src/components/page/ConvertDetails/flow/actionTypes.js